
import React from 'react';
import { Link } from 'react-router-dom';

interface PopularTopicsProps {
  topics: string[];
}

const PopularTopics: React.FC<PopularTopicsProps> = ({ topics }) => {
  return (
    <div className="mt-16">
      <h2 className="heading-lg mb-6 text-center">Popular Topics</h2>
      <div className="flex flex-wrap justify-center gap-4">
        {topics.map(topic => (
          <Link 
            key={topic} 
            to={`/blog/topic/${topic.toLowerCase().replace(/\s+/g, '-')}`}
            className="px-4 py-2 bg-white border border-gray-200 rounded-full text-itmgmt-dark-blue hover:bg-itmgmt-light-blue/20 transition-colors"
          >
            {topic}
          </Link>
        ))}
      </div>
    </div>
  );
};

export default PopularTopics;
